import React from "react";

export const Maintenance = () => {
	return <div className="maintenance" />;
};
